export interface NewsItem {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  time: string;
  hot: number;
  image: string;
  tag: string;
}

export interface TrendItem {
  rank: number;
  keyword: string;
  delta: string;
  heat: string;
  up: boolean;
}

export interface StarItem {
  name: string;
  tagline: string;
  field: string;
  works: string[];
  avatar: string;
  intro: string;
}

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "周冉《长风渡口》杀青特辑释出，剧组晒幕后花絮细节满满",
    excerpt: "《长风渡口》历时四个月拍摄正式杀青，官方释出的幕后特辑呈现了多个场景的高强度排练画面，观众对角色塑造与服化道还原度的讨论持续升温。",
    category: "剧集动态",
    time: "10 分钟前",
    hot: 986,
    image: "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20behind%20the%20scenes%20with%20director%20chair%20and%20lighting%20equipment%20in%20warm%20golden%20tone%2C%20movie%20camera%2C%20dramatic%20atmosphere&width=900&height=620&seq=news-n1&orientation=landscape",
    tag: "杀青",
  },
  {
    id: "n2",
    title: "陈屿单曲《夜航西飞》上线即登新歌榜前三，评论区网友热议",
    excerpt: "唱作人陈屿的新单曲《夜航西飞》发布后，凭借抓耳的旋律与克制的情感表达迅速攀升新歌榜，乐评人普遍关注其编曲上对城市夜景氛围的细腻描摹。",
    category: "音乐现场",
    time: "32 分钟前",
    hot: 872,
    image: "https://readdy.ai/api/search-image?query=studio%20music%20recording%20with%20vintage%20microphone%20and%20neon%20city%20night%20bokeh%2C%20singer%20silhouette%2C%20warm%20amber%20and%20crimson%20tone&width=900&height=620&seq=news-n2&orientation=landscape",
    tag: "新歌",
  },
  {
    id: "n3",
    title: "红毯瞬间：林晚棠高定礼服造型获时尚媒体盛赞",
    excerpt: "在某品牌年度盛典红毯上，林晚棠以一袭深红丝缎高定亮相，造型团队表示整体概念取自东方古典纹样，成为当晚讨论度最高的时尚话题之一。",
    category: "红毯造型",
    time: "1 小时前",
    hot: 764,
    image: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20fashion%20gown%20in%20deep%20crimson%20satin%20with%20dramatic%20golden%20backlight%2C%20glamorous%20event%20photography%2C%20editorial%20style&width=900&height=620&seq=news-n3&orientation=landscape",
    tag: "红毯",
  },
  {
    id: "n4",
    title: "《万家灯火》豆瓣评分走高，群像戏获观众认可",
    excerpt: "家庭群像剧《万家灯火》开播三周评分持续走高，网友点赞其对普通人生活细节的刻画，制片方透露后续剧情将迎来关键转折。",
    category: "剧集动态",
    time: "2 小时前",
    hot: 698,
    image: "https://readdy.ai/api/search-image?query=cozy%20warm%20family%20drama%20scene%20with%20soft%20window%20light%2C%20living%20room%20gathering%2C%20warm%20orange%20and%20cream%20tones%2C%20television%20drama%20still&width=900&height=620&seq=news-n4&orientation=landscape",
    tag: "口碑",
  },
  {
    id: "n5",
    title: "青年导演苏雨眠新片立项，聚焦都市女性创业题材",
    excerpt: "导演苏雨眠官宣新片项目，影片以三位都市女性合伙创业为主线，据片方透露目前已进入剧本打磨与选角阶段，消息一出引发行业期待。",
    category: "行业观察",
    time: "3 小时前",
    hot: 533,
    image: "https://readdy.ai/api/search-image?query=moody%20cinematic%20urban%20cityscape%20at%20dusk%20with%20office%20windows%20glowing%2C%20creative%20film%20project%20concept%2C%20warm%20tonal%20palette&width=900&height=620&seq=news-n5&orientation=landscape",
    tag: "新片",
  },
  {
    id: "n6",
    title: "乐坛盛典临近，主办方公布首批嘉宾名单引发讨论",
    excerpt: "年度音乐盛典主办方公布首批表演嘉宾名单，涵盖多位当红歌手与新锐唱作人，关于节目编排与现场首秀的猜测成为乐迷近期关注焦点。",
    category: "音乐现场",
    time: "5 小时前",
    hot: 486,
    image: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20crowd%20silhouettes%20and%20dramatic%20spotlights%2C%20live%20music%20award%20show%2C%20crimson%20and%20gold%20color%20scheme&width=900&height=620&seq=news-n6&orientation=landscape",
    tag: "盛典",
  },
  {
    id: "n7",
    title: "老戏骨沈伯言谈角色塑造：演员要先学会「忘记技巧」",
    excerpt: "在近期一次公开论坛上，老戏骨沈伯言分享多年表演心得，强调角色塑造应回归人物本身，金句频出引发年轻演员与观众的广泛共鸣。",
    category: "行业观察",
    time: "6 小时前",
    hot: 421,
    image: "https://readdy.ai/api/search-image?query=theater%20stage%20spotlight%20on%20an%20elder%20actor%20silhouette%20in%20front%20of%20red%20curtains%2C%20dramatic%20warm%20lighting%2C%20editorial&width=900&height=620&seq=news-n7&orientation=landscape",
    tag: "访谈",
  },
  {
    id: "n8",
    title: "高亚俊发布旅行影像日志，纪实风格获粉丝点赞",
    excerpt: "演员高亚俊在其社交账号发布一支旅行影像日志，以纪实镜头记录沿途人文风景，克制的旁白与画面节奏收获了不少「治愈系」评价。",
    category: "人物动态",
    time: "8 小时前",
    hot: 355,
    image: "https://readdy.ai/api/search-image?query=travel%20film%20journal%20aesthetic%20with%20retro%20camera%20and%20mountain%20landscape%2C%20documentary%20vlog%20style%2C%20warm%20film%20grain&width=900&height=620&seq=news-n8&orientation=landscape",
    tag: "Vlog",
  },
];

export const trendData: TrendItem[] = [
  { rank: 1, keyword: "周冉杀青幕后", delta: "新", heat: "982 万", up: true },
  { rank: 2, keyword: "陈屿夜航西飞", delta: "+12", heat: "876 万", up: true },
  { rank: 3, keyword: "红毯造型盘点", delta: "-1", heat: "741 万", up: false },
  { rank: 4, keyword: "万家灯火评分", delta: "+6", heat: "688 万", up: true },
  { rank: 5, keyword: "年度音乐盛典", delta: "新", heat: "592 万", up: true },
  { rank: 6, keyword: "苏雨眠新片立项", delta: "+3", heat: "510 万", up: true },
  { rank: 7, keyword: "高亚俊旅行日志", delta: "-2", heat: "433 万", up: false },
  { rank: 8, keyword: "沈伯言谈演技", delta: "+9", heat: "388 万", up: true },
  { rank: 9, keyword: "时尚品牌盛典", delta: "-5", heat: "302 万", up: false },
  { rank: 10, keyword: "金秋剧场排播", delta: "新", heat: "256 万", up: true },
];

export const starList: StarItem[] = [
  {
    name: "周冉",
    tagline: "可塑性极强的实力派",
    field: "影视演员",
    works: ["长风渡口", "灯火阑珊", "城南旧事新编"],
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20confident%20young%20chinese%20actor%20in%20warm%20studio%20light%2C%20magazine%20style%2C%20minimal%20cream%20background&width=420&height=520&seq=star-zhou-ran&orientation=portrait",
    intro: "以细腻的情感表达著称，近年在电影与剧集领域双向发力。",
  },
  {
    name: "陈屿",
    tagline: "城市情绪的书写者",
    field: "唱作歌手",
    works: ["夜航西飞", "无人海岸", "漫游指南"],
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20thoughtful%20young%20chinese%20male%20singer%20with%20guitar%2C%20warm%20neon%20ambient%20light%2C%20magazine%20style&width=420&height=520&seq=star-chen-yu&orientation=portrait",
    intro: "擅长以克制旋律勾勒都市人的孤独与温柔，词作有辨识度。",
  },
  {
    name: "林晚棠",
    tagline: "风格与演技并重",
    field: "影视演员 · 时尚",
    works: ["浮光", "夜色温柔", "风起长安"],
    avatar: "https://readdy.ai/api/search-image?query=editorial%20fashion%20portrait%20of%20an%20elegant%20young%20chinese%20actress%20in%20crimson%20dress%2C%20glamorous%20soft%20light%2C%20magazine%20style&width=420&height=520&seq=star-lin-wantang&orientation=portrait",
    intro: "镜头感极强，横跨影视与时尚领域，造型话题度常年居前。",
  },
  {
    name: "沈伯言",
    tagline: "深耕表演四十载",
    field: "实力派戏骨",
    works: ["万家灯火", "山河故人", "岁月留声"],
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20dignified%20senior%20chinese%20actor%20with%20gray%20hair%2C%20warm%20theater%20light%2C%20magazine%20style&width=420&height=520&seq=star-shen-boyan&orientation=portrait",
    intro: "话剧与影视双栖，擅长塑造有分量的普通人角色。",
  },
  {
    name: "苏雨眠",
    tagline: "新锐女性导演",
    field: "导演 · 编剧",
    works: ["霓虹之下", "逆行人生"],
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20young%20chinese%20female%20director%20holding%20a%20film%20camera%2C%20creative%20studio%20warm%20light%2C%20magazine%20style&width=420&height=520&seq=star-su-yumian&orientation=portrait",
    intro: "作品关注女性成长与都市议题，视觉语言自成一体。",
  },
  {
    name: "高亚俊",
    tagline: "文艺气质的探索者",
    field: "影视演员",
    works: ["云上旅人", "时间的褶皱"],
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20laid%20back%20young%20chinese%20actor%20in%20casual%20jacket%2C%20travel%20documentary%20mood%2C%20warm%20tone%2C%20magazine%20style&width=420&height=520&seq=star-gao-yajun&orientation=portrait",
    intro: "热衷于以影像记录生活，角色气质清新而不流俗。",
  },
];

export const faqList = [
  {
    q: "本站更新的明星资讯都来自哪里？",
    a: "本站内容均整理自公开渠道的新闻报道、官方发布与已公开的采访素材，对时效性强、来源多元的话题我们会标注事件进展，供你快速把握脉络，不收录任何未经证实的私人录音或聊天记录类材料。",
  },
  {
    q: "「一次看全事件脉络」具体是什么意思？",
    a: "我们会对同一热点事件下的剧集动态、红毯造型、音乐现场、行业访谈等不同形式的公开内容做汇总串联，按时间顺序整理进展，让你不用在各个平台来回切换就能看清来龙去脉。",
  },
  {
    q: "为什么分为视频、图文、长文等不同栏目？",
    a: "不同形式的内容阅读场景不同：短视频适合快速了解现场，图文长文适合深度理解背景。按形式分类能让内容浏览更高效，也方便你按喜好选择。",
  },
  {
    q: "内容里的「热榜趋势」多久更新一次？",
    a: "热榜基于公开讨论热度滚动更新，我们会在站内标注排行变化与上升趋势，帮助判断哪些话题正处于讨论高点。",
  },
  {
    q: "发现信息有误，应该如何反馈？",
    a: "你可以在页脚找到反馈入口，或将更正说明发送至我们用于内容核实的工作邮箱，收到后会第一时间核对公开信源并修正。",
  },
];